import * as Sentry from '@sentry/angular-ivy';
import { APP_INITIALIZER, ApplicationConfig, ErrorHandler, LOCALE_ID, importProvidersFrom } from '@angular/core';
import { CookiesService } from '@services/cookies/cookies.service';
import { HttpClient, provideHttpClient } from '@angular/common/http';
import { HttpErrorService, httpErrorServiceFactory } from './services/http-error/http-error.service';
import { Router, provideRouter, withComponentInputBinding } from '@angular/router';
import { TranslateLoader, TranslateModule, TranslateService } from '@ngx-translate/core';
import { UsersService, usersServiceFactory } from './services/users/users.service';
import { localeInitializerFactory } from '@shared/factories/locale-init';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideToastr } from 'ngx-toastr';
import { routes } from './app.routes';
import { translationInitializerFactory } from '@shared/factories/translations-init';
import { translationLoaderFactory } from '@shared/factories/translations-loader';

export const appConfig: ApplicationConfig = {
    providers: [
        provideAnimationsAsync(),
        provideHttpClient(),
        provideToastr({
            timeOut: 3000,
            preventDuplicates: true,
            closeButton: true
        }),
        provideRouter(routes, withComponentInputBinding()),
        {
            provide: APP_INITIALIZER,
            useFactory: httpErrorServiceFactory,
            deps: [HttpErrorService],
            multi: true
        },
        {
            provide: APP_INITIALIZER,
            useFactory: usersServiceFactory,
            deps: [UsersService],
            multi: true
        },
        {
            provide: APP_INITIALIZER,
            useFactory: translationInitializerFactory,
            deps: [CookiesService, TranslateService],
            multi: true
        },
        {
            provide: LOCALE_ID,
            useFactory: localeInitializerFactory,
            deps: [CookiesService]
        },
        {
            provide: ErrorHandler,
            useValue: Sentry.createErrorHandler({
                showDialog: true
            })
        },
        {
            provide: Sentry.TraceService,
            deps: [Router]
        },
        {
            provide: APP_INITIALIZER,
            useFactory: () => () => {},
            deps: [Sentry.TraceService],
            multi: true
        },
        importProvidersFrom(
            TranslateModule.forRoot({
                loader: {
                    provide: TranslateLoader,
                    useFactory: translationLoaderFactory,
                    deps: [HttpClient]
                }
            })
        )
    ]
};
